<template>
  <div class="background-primary-color crossed d-flex justify-center mb-8 position-relative">
    <status-delivering :is-crossed="true" />
  </div>
</template>

<script>
import StatusDelivering from "@/assets/order_status/delivering.vue";

export default {
  name: "NoDeliveryIcon",
  components: { StatusDelivering }
};
</script>

<style scoped>
.crossed {
  border-radius: 50%;
  width: 100px;
  height: 100px;
}
</style>
